import React from "react";
import Barcode from "react-barcode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VbDEwVZL7UVZS1AcfX08";

const ProfileInfo = () => {
  const rawIds = sessionStorage.getItem("registration_ids");
  const registrationIds = rawIds ? JSON.parse(rawIds) : {};
  const entries = Object.entries(registrationIds);

  const userString = sessionStorage.getItem("user");
  const currentUser = userString ? JSON.parse(userString) : null;
  const isPaid = currentUser && currentUser.paid == 1;
  const paymentPage = sessionStorage.getItem("payment_page");

  return (
    <div className="container" style={{ direction: "rtl" }}>
      {/* Not-paid banner else paid banner */}
      {!isPaid && (
        <div className="alert alert-warning text-center" role="alert">
          <strong>لم يتم تأكيد اشتراكك حتى الآن.</strong>
          <br />
          بمجرد استلام الدفع سيتم تفعيل حسابك خلال 48 ساعة وأتاحة الوصول إلى المحاضرات.
        </div>
      )}

      {isPaid && (
        <div className="alert alert-success text-center" role="alert">
          <strong>تم تأكيد دفع اشتراكك ⭐</strong>
        </div>
      )}

      <div className="d-flex flex-column align-items-center mb-4">
        <h4 className="alert alert-info text-center" style={{ marginBottom: "20px" }}>
          هذا هو رمز التسجيل الخاص بك. الرجاء الاحتفاظ به, يستخدم لتسجيل حضورك عند حضور المحاضرات داخل الكنيسة.
        </h4>

        {entries.length === 0 ? (
          <div className="alert alert-warning" role="alert">
            لا توجد بيانات تسجيل متاحة
          </div>
        ) : (
          entries.map(([firstName, fullId]) => (
            <div
              key={fullId}
              className="card"
              style={{
                marginBottom: "20px",
                padding: "20px",
                width: "100%",
                maxWidth: "400px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h5 style={{ marginBottom: "12px" }}>{firstName}</h5>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <Barcode
                  value={String(fullId)}
                  width={2}
                  height={80}
                  fontSize={14}
                  displayValue={true}
                />
              </div>
            </div>
          ))
        )}
        {paymentPage && (
          <div className="card" style={{ marginTop: "20px", direction: "rtl", width: "100%", maxWidth: "700px" }}>
            <div className="card-body" style={{ textAlign: "right", direction: "rtl" }}>
              <div
                dangerouslySetInnerHTML={{ __html: paymentPage }}
                style={{
                  textAlign: "right",
                  direction: "rtl",
                  fontFamily: "Arial, sans-serif",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  wordBreak: "normal",
                  unicodeBidi: "embed",
                }}
              />
            </div>
          </div>
        )}
        <a
          href={WHATSAPP_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "30px",
            left: "20px",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "6px",
            textDecoration: "none",
            maxWidth: "80px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#25D366",
              borderRadius: "50%",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FontAwesomeIcon icon={faWhatsapp} style={{ color: "white", fontSize: "28px" }} />
          </div>
          <span
            style={{
              fontSize: "10px",
              color: "#25D366",
              fontWeight: "600",
              lineHeight: "1.3",
              direction: "rtl",
            }}
          >
            انضم لقناة الواتساب لتتقى التنبيهات الخاصة بالدورة
          </span>
        </a>
      </div>
    </div>
  );
};

export default ProfileInfo;
